export const BOTTOM_BAR_ICONS_LIMIT = 4;
